"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _GridContainer = _interopRequireDefault(require("../../components/Grid/GridContainer/GridContainer"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _nukaCarousel = _interopRequireDefault(require("nuka-carousel"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _Quote = _interopRequireDefault(require("../../components/Quote/Quote"));
var _Callout = _interopRequireDefault(require("../../elements/Callout/Callout"));
var _Paragraph = _interopRequireDefault(require("../../elements/Paragraph/Paragraph"));
var _CalloutQuote = _interopRequireDefault(require("../../elements/CalloutQuote/CalloutQuote"));
var _DataCallout = _interopRequireDefault(require("../../components/DataCallout/DataCallout"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _excluded = ["className", "children"],
  _excluded2 = ["className", "children"],
  _excluded3 = ["className", "children"],
  _excluded4 = ["headingCopy", "subheadingCopy", "resources"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var StyledLayoutContainer = (0, _styledComponents.default)(_GridContainer.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 50px !important;\n  padding-left: 10px !important; \n  padding-right: 10px !important;\n  overflow: hidden;\n  background-color: var(--bf-light-gray);\n"])));
var StyledCarousel = (0, _styledComponents.default)(_nukaCarousel.default)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\npadding-top: 20px !important;\npadding-bottom: 20px !important;\nmargin-bottom: 4rem;\n"])));
var StyledResourceItem = (0, _styledComponents.default)(_Grid.default)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n  background-color: var(--bf-core-white);\n  border-style: solid;\n  border-width: 3px;\n  border-radius: 20px;\n  color: var(--bf-core-gray);\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  padding-top: 2rem;\n  padding-bottom: 1rem;\n  margin-left: 1rem;\n  margin-right: 1rem;\n  box-shadow: 1px 1px 20px 2px rgba(0, 0, 0, 0.1);\n  "])));
var StyledSectionHeading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    h1: true,
    teal: true,
    bold: true,
    className: className
  }, " ", children, " ");
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n  padding-bottom: 2rem;\n  padding-top: 2rem;\n"])));
var StyledSectionSubheading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  return _react.default.createElement(_Heading.default, {
    h3: true,
    white: true,
    special: true,
    className: className
  }, " ", children, " ");
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var ProofCarouselLarge = (0, _styledComponents.default)(function (_ref3) {
  var className = _ref3.className,
    children = _ref3.children,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return _react.default.createElement(StyledCarousel, {
    defaultControlsConfig: {
      nextButtonText: '>',
      prevButtonText: '<'
    },
    slidesToShow: 4,
    className: className,
    adaptiveHeight: true
  }, children);
})(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var ProofCarouselMedium = (0, _styledComponents.default)(function (_ref4) {
  var className = _ref4.className,
    children = _ref4.children,
    props = (0, _objectWithoutProperties2.default)(_ref4, _excluded2);
  return _react.default.createElement(StyledCarousel, {
    defaultControlsConfig: {
      nextButtonText: '>',
      prevButtonText: '<'
    },
    slidesToShow: 3,
    className: className,
    adaptiveHeight: true
  }, children);
})(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var ProofCarouselSmall = (0, _styledComponents.default)(function (_ref5) {
  var className = _ref5.className,
    children = _ref5.children,
    props = (0, _objectWithoutProperties2.default)(_ref5, _excluded3);
  return _react.default.createElement(StyledCarousel, {
    defaultControlsConfig: {
      nextButtonText: '>',
      prevButtonText: '<'
    },
    slidesToShow: 2,
    className: className,
    adaptiveHeight: true
  }, children);
})(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var Resources = function Resources(_ref6) {
  var headingCopy = _ref6.headingCopy,
    subheadingCopy = _ref6.subheadingCopy,
    resources = _ref6.resources,
    props = (0, _objectWithoutProperties2.default)(_ref6, _excluded4);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(StyledLayoutContainer, Object.assign({
    justifyContent: "flex-start"
  }, props), _react.default.createElement(StyledSectionHeading, Object.assign({
    xs: 12
  }, props), headingCopy), _react.default.createElement(_Grid.default, {
    item: true,
    sx: {
      display: {
        xl: 'block',
        xs: 'none',
        sm: 'none',
        md: 'none',
        lg: 'block'
      }
    }
  }, _react.default.createElement(ProofCarouselLarge, null, resources.map(function (resource) {
    return _react.default.createElement(StyledResourceItem, null, _react.default.createElement(_Heading.default, {
      h2: true,
      gray: true
    }, resource));
  }))), _react.default.createElement(_Grid.default, {
    item: true,
    sx: {
      display: {
        xl: 'none',
        xs: 'none',
        sm: 'block',
        md: 'block',
        lg: 'none'
      }
    }
  }, _react.default.createElement(ProofCarouselMedium, null, resources.map(function (resource) {
    return _react.default.createElement(StyledResourceItem, null, _react.default.createElement(_Heading.default, {
      h2: true,
      gray: true
    }, resource));
  }))), _react.default.createElement(_Grid.default, {
    item: true,
    sx: {
      display: {
        xl: 'none',
        xs: 'block',
        sm: 'none',
        md: 'none',
        lg: 'none'
      }
    }
  }, _react.default.createElement(ProofCarouselSmall, null, resources.map(function (resource) {
    return _react.default.createElement(StyledResourceItem, null, _react.default.createElement(_Heading.default, {
      h2: true,
      gray: true
    }, resource));
  })))));
};
var _default = Resources;
exports.default = _default;